import React from "react";
import {createPortal} from "react-dom";
import {getGoogleFontName} from "@root/_utils";

export default function TextMessage({
  giftCard,
  messageText,
  recipientName,
  messageFrom,
  translation,
  salutation = null
}) {

  let fullName = salutation !== null ? `${salutation} ${recipientName},` : `${recipientName},`;

  const messageMarkup = (
    <>
      <p style={{
        fontFamily: getGoogleFontName(giftCard.message_font_family)
      }}
      className="gc__text_message">
        {fullName}
      </p>
      <br />
      <p style={{
        fontFamily: getGoogleFontName(giftCard.message_font_family)
      }}
      className="gc__text_message">
        {messageText}
      </p>
      <br />
      <p  style={{
        fontFamily: getGoogleFontName(giftCard.signature_font_family)
      }}
      className="gc__text_message">
        {messageFrom}
      </p>
    </>
  );

  const constraintMarkup = createPortal(
    (
      <div id="gcpMessageSizing">
        <div>{/** Keep this Flex div */}
          <div className="gcp__message-sizing-contraint-container">
            <div className="gcp__message-sizing-content">
            {messageMarkup}
            </div>
          </div>
        </div>
      </div>
    ),
    document.body
  );

  return (
    <>
      {constraintMarkup}
      <div className="gc__message_wrapper">
        <div>{/** Keep this Flex div */}
          <div className="gcp__message-content-size">
            {messageMarkup}
          </div>
        </div>
      </div>
    </>
  )
}
